import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { mealPlanActions } from '_store';

export { List };

function List() {
    const mealPlans = useSelector(x => x.mealPlans.list);
    let currentWeekDate = useSelector(x => x.mealPlans.currentWeekDate);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(mealPlanActions.getMealPlanWeek());
    }, []);

    function nextWeek(selectedDate) { 
        selectedDate = addDays(selectedDate, 7);
        dispatch(mealPlanActions.setCurrentWeek(selectedDate.toISOString().slice(0, 10)));
        dispatch(mealPlanActions.getMealPlanWeek())
    }

    function lastWeek(selectedDate) { 
        selectedDate = addDays(selectedDate, -7);
        dispatch(mealPlanActions.setCurrentWeek(selectedDate.toISOString().slice(0, 10)));
        dispatch(mealPlanActions.getMealPlanWeek())
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

    return (
        <div>
            <h1>MealPlans</h1>
            <div>
                <button className="btn btn-primary me-1" onClick={() => lastWeek(currentWeekDate)}>Last Week</button>
                <button className="btn btn-primary" onClick={() => nextWeek(currentWeekDate)}>Next Week</button>
            </div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Date</th>
                        <th style={{ width: '40%' }}>Description</th>
                        <th style={{ width: '20%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {mealPlans?.value?.map(mealPlan =>
                        <tr key={mealPlan.date}>
                            <td>{mealPlan.date}</td>
                            <td>{mealPlan.mealName}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                                <Link to={`edit/${mealPlan.date}`} className="btn btn-sm btn-primary me-1">Edit</Link>                                
                            </td>
                        </tr>
                    )}
                    {mealPlans?.loading &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <span className="spinner-border spinner-border-lg align-center"></span>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );

};